import Vue from 'vue'

import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

function renderButtonSupport(h) {
  if (this.paymentResult === 'fail') {
    return h(
      button,
      {
        props: {
          label: this.getTranslate('misc.buttons.support'),
          mode: buttonModes.flat,
          color: Colors.primary
        },
        on: {
          click: () => {
            Vue.router.push({ name: 'support' })
          }
        }
      }
    )
  }
}

function renderInfo(h) {
  let color = Colors.error
  let icon = icons.error
  if (this.paymentResult === 'success') {
    color = Colors.success
    icon = icons.check_circle
  }

  return h(
    'div',
    {
      class: `${Services.payments}-result`
    },
    [
      h(
        info,
        {
          props: {
            value: this.paymentResult && this.getTranslate(`${Services.payments}.contents.payment.result.${this.paymentResult}`),
            color,
            icon
          }
        }
      )
    ]
  )
}
function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      renderButtonSupport.call(this, h),

      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.show = false
              Vue.router.push('/')
            }
          }
        }
      )
    ]
  )
}
export default function(h) {
  return h(
    components.dialog,
    {
      props: {
        rounded: true,
        value: this.show,
        closeOnEsc: false,
        closeOnClick: false,
        maxWidth: 400
      },
      on: {
        input: event => {
          this.show = event
        }
      }
    },
    [
      renderInfo.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}
